import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default {
    fetch: (search_filter = "", column = 'id', orderBy = 'ASC') => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                query {
                    getStatus
                    (
                        search_filter: "${search_filter}",
                        orderBy: ["${column}", "${orderBy}"]
                    )
                    {
                        id,
                        name,
                        step,
                        color,
                        integration_id,
                        is_editable
                    }
                }
            `
        });
    },
    fetchPaginated: (sortName = "id", page, itemsPerPage, type = "ASC", word = "") => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', formatGraphqlBody(
            'query',
            'getStatusPaginated',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'id',
                    1: 'name',
                    2: 'step',
                    3: 'color',
                    4: 'integration_id',
                    5: 'is_editable'
                }
            },
            {
                orderBy: [sortName, type],
                search_filter: word,
                pagination_page: page,
                pagination_limit: itemsPerPage
            }
        ));
    },
    create: (data) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                mutation {
                    createStatus
                    (
                        name: "${data.name}",
                        step: "${data.step}",
                        color: "${data.color}"
                    )
                    {
                        name,
                        step,
                        color
                    }
                }
            `
        })
    },
    update: (id, data) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
           query: `
                mutation {
                    updateStatus
                    (
                        id: ${id},
                        name: "${data.name}",
                        step: "${data.step}",
                        color: "${data.color}"
                    )
                    {
                        id,
                        name,
                        step,
                        color
                    }
                }
           ` 
        }) 
    },
    delete: ({ id, newOrdersStatusId = null }) => {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
        return axios.post('', {
            query: `
                mutation {
                    deleteStatus
                    (
                        id: ${id},
                        ` + (newOrdersStatusId !== null ? ('new_orders_status_id: ' + newOrdersStatusId) : '') + `
                    )
                }
            `
        })
    }
}
